export default "__VITE_ASSET__650780e7__"